var map = {
	"./BD.svg": "2d26",
	"./CNG.svg": "4ad6",
	"./E85.svg": "8760",
	"./ELEC.svg": "c92d",
	"./HY.svg": "793e",
	"./LNG.svg": "4fed",
	"./LPG.svg": "f627",
	"./RD.svg": "07f9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "388d";